(function () {
  function initRentalRequest(section) {
    var form = section.querySelector('form.tcg-rental-request__form');
    if (!form) return;

    var steps = Array.prototype.slice.call(section.querySelectorAll('[data-tcg-step]'));
    var tabs = Array.prototype.slice.call(section.querySelectorAll('[data-tcg-step-tab]'));
    var progress = section.querySelector('[data-tcg-progress]');
    var prevButton = section.querySelector('[data-tcg-prev]');
    var nextButton = section.querySelector('[data-tcg-next]');
    var submitButton = section.querySelector('[data-tcg-submit]');
    var bodyField = form.querySelector('[data-tcg-summary-body]');
    var requestIdField = form.querySelector('[data-tcg-request-id]');
    var submittedAtField = form.querySelector('[data-tcg-submitted-at]');
    var pageUrlField = form.querySelector('[data-tcg-page-url]');
    var routingToField = form.querySelector('[data-tcg-routing-to]');
    var routingCcField = form.querySelector('[data-tcg-routing-cc]');
    var routingQaField = form.querySelector('[data-tcg-routing-qa]');
    var routingPreview = section.querySelector('[data-tcg-routing-preview]');
    var routingPreviewCopy = section.querySelector('[data-tcg-routing-preview-copy]');
    var honeypot = form.querySelector('[data-tcg-honeypot]');
    var billingSame = form.querySelector('[data-tcg-billing-same]');
    var billingGroup = form.querySelector('[data-tcg-billing-group]');
    var billingFields = Array.prototype.slice.call(form.querySelectorAll('[data-tcg-billing-field]'));
    var submissionDisabled = section.getAttribute('data-tcg-submission-disabled') === 'true';
    var primaryRecipient = (section.getAttribute('data-tcg-primary-recipient') || '').trim();
    var temporaryQaRecipient = (section.getAttribute('data-tcg-temporary-qa-recipient') || '').trim();
    var currentStep = 0;
    var requestId = '';

    if (!steps.length) return;

    function setStep(index) {
      currentStep = Math.max(0, Math.min(index, steps.length - 1));

      steps.forEach(function (step, stepIndex) {
        step.hidden = stepIndex !== currentStep;
      });

      tabs.forEach(function (tab, tabIndex) {
        if (tabIndex === currentStep) {
          tab.setAttribute('aria-current', 'step');
        } else {
          tab.removeAttribute('aria-current');
        }
      });

      if (progress) {
        progress.style.width = (((currentStep + 1) / steps.length) * 100).toFixed(2) + '%';
      }

      if (prevButton) prevButton.hidden = currentStep === 0;
      if (nextButton) nextButton.hidden = currentStep === steps.length - 1;
      if (submitButton) submitButton.hidden = currentStep !== steps.length - 1;
    }

    function syncChoiceStates() {
      Array.prototype.slice.call(section.querySelectorAll('.tcg-rental-request__choice')).forEach(function (choice) {
        var input = choice.querySelector('input[type="radio"], input[type="checkbox"]');
        choice.classList.toggle('is-selected', !!input && input.checked);
      });
    }

    function syncBillingAddressState() {
      var sameAsDelivery = !!billingSame && billingSame.checked;

      if (billingGroup) billingGroup.hidden = sameAsDelivery;

      billingFields.forEach(function (field) {
        if (sameAsDelivery) {
          field.disabled = true;
          field.removeAttribute('data-tcg-required');
          setInvalid(field, false, '');
        } else {
          field.disabled = false;
          field.setAttribute('data-tcg-required', '');
        }
      });
    }

    function selectedBranchRouting() {
      var locationField = form.querySelector('[data-tcg-branch-location]');
      var option = locationField && locationField.options ? locationField.options[locationField.selectedIndex] : null;
      var branchName = option ? (option.value || '').trim() : '';
      var branchEmail = option ? (option.getAttribute('data-tcg-branch-email') || '').trim() : '';

      return {
        branchEmail: branchEmail,
        branchName: branchName,
      };
    }

    function routingState() {
      var branch = selectedBranchRouting();
      var cc = [];

      if (branch.branchEmail) cc.push(branch.branchEmail);
      if (temporaryQaRecipient) cc.push(temporaryQaRecipient + ' (temporary QA)');

      return {
        branchEmail: branch.branchEmail,
        branchName: branch.branchName,
        cc: cc,
        primary: primaryRecipient || 'rentals@thecontainerguy.ca',
        qa: temporaryQaRecipient,
      };
    }

    function updateRoutingFields() {
      var routing = routingState();
      var ccValue = routing.cc.join(', ');

      if (routingToField) routingToField.value = routing.primary;
      if (routingCcField) routingCcField.value = ccValue;
      if (routingQaField) routingQaField.value = routing.qa;

      if (routingPreview && routingPreviewCopy) {
        if (routing.branchName && routing.branchName !== 'Not sure') {
          routingPreviewCopy.textContent = 'Intended routing: To ' + routing.primary + '; CC ' + (ccValue || 'branch copy not configured') + '.';
        } else {
          routingPreviewCopy.textContent = 'Intended routing: To ' + routing.primary + '; branch CC will be chosen by TCG after the nearest location is confirmed' + (routing.qa ? '; temporary QA copy ' + routing.qa + '.' : '.');
        }
      }

      return routing;
    }

    function fieldValue(field) {
      if (!field) return '';

      if (field.type === 'radio') {
        var group = form.elements[field.name];
        var checked = null;

        if (group && typeof group.length === 'number') {
          checked = Array.prototype.slice.call(group).find(function (item) {
            return item.checked;
          });
        } else if (group && group.checked) {
          checked = group;
        }

        return checked ? checked.value.trim() : '';
      }

      if (field.type === 'checkbox') {
        return field.checked ? field.value.trim() : '';
      }

      return (field.value || '').trim();
    }

    function hasEnoughPhoneDigits(value) {
      var digits = (value || '').replace(/\D/g, '');
      return digits.length >= 10;
    }

    function isReasonablePhone(value) {
      return /^[+()\-\.\s\dextEXT]+$/.test(value) && hasEnoughPhoneDigits(value);
    }

    function isCanadianPostalCode(value) {
      return /^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ -]?\d[ABCEGHJ-NPRSTV-Z]\d$/i.test(value);
    }

    function validationMessage(field, value, defaultMessage) {
      if (!value) return defaultMessage;

      if (field.type === 'email' && field.validity && field.validity.typeMismatch) {
        return 'Enter a valid email address.';
      }

      if (field.type === 'number' && field.validity && !field.validity.valid) {
        return 'Enter a whole number of 1 or more.';
      }

      if ((field.type === 'tel' || field.getAttribute('data-tcg-format') === 'phone') && !isReasonablePhone(value)) {
        return defaultMessage && defaultMessage !== 'Enter a phone number.'
          ? defaultMessage
          : 'Enter a valid phone number with area code.';
      }

      if (field.getAttribute('data-tcg-format') === 'postal-code' && value && !isCanadianPostalCode(value)) {
        return 'Enter a valid Canadian postal code.';
      }

      return '';
    }

    function setInvalid(field, invalid, message) {
      var id = field.getAttribute('id');
      var error = id ? section.querySelector('[data-tcg-error-for="' + id + '"]') : null;

      field.setAttribute('aria-invalid', invalid ? 'true' : 'false');

      if (error) {
        error.textContent = invalid ? message : '';
        error.classList.toggle('is-visible', !!invalid);
      }
    }

    function validateStep(step) {
      var valid = true;
      var firstInvalid = null;
      syncBillingAddressState();

      var requiredFields = Array.prototype.slice.call(step.querySelectorAll('[data-tcg-required], [data-tcg-format]')).filter(function (field) {
        return !field.disabled;
      });
      var visitedRadioGroups = {};

      requiredFields.forEach(function (field) {
        var isRequired = field.hasAttribute('data-tcg-required');

        if (field.type === 'radio') {
          if (visitedRadioGroups[field.name]) return;
          visitedRadioGroups[field.name] = true;
        }

        var value = fieldValue(field);
        var message = field.getAttribute('data-tcg-error') || 'Please complete this field.';
        var formatMessage = value ? validationMessage(field, value, message) : '';

        if ((isRequired && !value) || formatMessage) {
          valid = false;
          setInvalid(field, true, formatMessage || message);
          if (!firstInvalid) firstInvalid = field;
        } else {
          setInvalid(field, false, '');
        }
      });

      return { valid: valid, firstInvalid: firstInvalid };
    }

    function validateAllSteps() {
      for (var i = 0; i < steps.length; i += 1) {
        var result = validateStep(steps[i]);
        if (!result.valid) {
          setStep(i);
          if (result.firstInvalid) result.firstInvalid.focus({ preventScroll: false });
          return false;
        }
      }

      return true;
    }

    function collectSummaryRows(scope) {
      var rows = [];
      var fields = Array.prototype.slice.call(scope.querySelectorAll('[data-tcg-summary-label]')).filter(function (field) {
        return !field.disabled;
      });
      var radioGroups = {};

      fields.forEach(function (field) {
        var label = field.getAttribute('data-tcg-summary-label');
        var value = '';

        if (field.type === 'radio') {
          if (radioGroups[field.name]) return;
          radioGroups[field.name] = true;
          value = fieldValue(field);
        } else if (field.type === 'checkbox') {
          if (!field.checked) return;
          value = field.value;
        } else {
          value = fieldValue(field);
        }

        if (label && value) rows.push(label + ': ' + value);
      });

      return rows;
    }

    function collectSummaryGroups() {
      return steps.map(function (step) {
        var heading = step.querySelector('.tcg-rental-request__step-header h3');
        var rows = collectSummaryRows(step);

        return {
          heading: heading ? heading.textContent.trim().toUpperCase() : 'DETAILS',
          rows: rows,
        };
      }).filter(function (group) {
        return group.rows.length;
      });
    }

    function pad(value) {
      return String(value).padStart(2, '0');
    }

    function makeRequestId(date) {
      var random = Math.random().toString(36).slice(2, 6).toUpperCase();

      return [
        'RR',
        date.getFullYear().toString() + pad(date.getMonth() + 1) + pad(date.getDate()),
        pad(date.getHours()) + pad(date.getMinutes()) + pad(date.getSeconds()),
        random,
      ].join('-');
    }

    function localTimestamp(date) {
      try {
        return new Intl.DateTimeFormat('en-CA', {
          year: 'numeric',
          month: 'short',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          timeZoneName: 'short',
        }).format(date);
      } catch (error) {
        return date.toLocaleString();
      }
    }

    function renderSummaryGroups(groups) {
      var lines = [];

      groups.forEach(function (group) {
        lines.push(group.heading);
        group.rows.forEach(function (row) {
          lines.push(row);
        });
        lines.push('');
      });

      return lines;
    }

    function populateSummary() {
      var submittedDate = new Date();
      var submittedAt = submittedDate.toISOString();
      var pageUrl = window.location.href;
      var groups = collectSummaryGroups();

      updateRoutingFields();
      if (!requestId) requestId = makeRequestId(submittedDate);

      var summary = [
        'TCG START RENTAL REQUEST',
        'Request ID: ' + requestId,
        'Submitted: ' + localTimestamp(submittedDate),
        'Source: ' + pageUrl,
        '',
      ].concat(renderSummaryGroups(groups)).join('\n').trim();

      if (bodyField) bodyField.value = summary;
      if (requestIdField) requestIdField.value = requestId;
      if (submittedAtField) submittedAtField.value = submittedAt;
      if (pageUrlField) pageUrlField.value = pageUrl;
    }

    function openDatePicker(field) {
      if (!field || field.type !== 'date' || typeof field.showPicker !== 'function') return;

      var now = Date.now();
      var lastOpenedAt = Number(field.getAttribute('data-tcg-last-picker-at') || 0);
      if (now - lastOpenedAt < 300) return;
      field.setAttribute('data-tcg-last-picker-at', String(now));

      try {
        field.showPicker();
      } catch (error) {
        // showPicker only works during direct user activation in supporting browsers.
      }
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        if (index <= currentStep || validateStep(steps[currentStep]).valid) {
          setStep(index);
        }
      });
    });

    if (prevButton) {
      prevButton.addEventListener('click', function () {
        setStep(currentStep - 1);
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', function () {
        var result = validateStep(steps[currentStep]);
        if (result.valid) {
          setStep(currentStep + 1);
        } else if (result.firstInvalid) {
          result.firstInvalid.focus({ preventScroll: false });
        }
      });
    }

    if (submitButton) {
      submitButton.addEventListener('click', function (event) {
        if (!submissionDisabled) return;

        event.preventDefault();
        if (!validateAllSteps()) return;

        populateSummary();
      });
    }

    form.addEventListener('input', function (event) {
      var field = event.target.closest('[data-tcg-required], [data-tcg-format]');
      syncChoiceStates();
      syncBillingAddressState();
      updateRoutingFields();
      if (!field) return;

      var value = fieldValue(field);
      if (!value || !validationMessage(field, value, field.getAttribute('data-tcg-error') || 'Please complete this field.')) {
        setInvalid(field, false, '');
      }
    });

    form.addEventListener('change', function (event) {
      var field = event.target.closest('[data-tcg-required], [data-tcg-format]');
      syncChoiceStates();
      syncBillingAddressState();
      updateRoutingFields();
      if (!field) return;

      var value = fieldValue(field);
      if (!value || !validationMessage(field, value, field.getAttribute('data-tcg-error') || 'Please complete this field.')) {
        setInvalid(field, false, '');
      }
    });

    Array.prototype.slice.call(form.querySelectorAll('input[type="date"]')).forEach(function (field) {
      field.addEventListener('pointerdown', function () {
        openDatePicker(field);
      });

      field.addEventListener('click', function () {
        openDatePicker(field);
      });
    });

    form.addEventListener('submit', function (event) {
      if (submissionDisabled) {
        event.preventDefault();
        return;
      }

      if (honeypot && honeypot.value.trim()) {
        event.preventDefault();
        return;
      }

      if (!validateAllSteps()) {
        event.preventDefault();
        return;
      }

      populateSummary();
    });

    setStep(0);
    syncChoiceStates();
    syncBillingAddressState();
    updateRoutingFields();
  }

  document.addEventListener('DOMContentLoaded', function () {
    Array.prototype.slice.call(document.querySelectorAll('[data-tcg-rental-request-section]')).forEach(initRentalRequest);
  });
})();
